const getters = {
  list: state => state.list,
  rejectedlist: state => state.rejectedlist,
  isLoading: state => state.isLoading,
  filter: state => state.filter,
  rejectionFilter: state => state.rejectionFilter,
  hasEmpty: state => state.hasEmpty,
  isPaginating: state => state.isPaginating,
  isTransporterLoading: state => state.isTransporterLoading,
};
export default getters;
